import React from 'react'

import { PlusOutlined } from '@ant-design/icons'
import PurchaseOrderListView from '@components/shared/purchaseOrders/PurchaseOrderListView'
import { useAdminNotification } from '@contexts/admin/AdminNotificationContext'
import ListPageHeader from '@shared/ListPageHeader'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import purchaseOrderService from '@services/admin/purchaseOrderService'
import supplierService from '@services/admin/supplierService'

export default function AdminPurchaseOrderList() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { addJob } = useAdminNotification()

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['purchase_orders', 'purchase_orders.list']}
        actions={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate('/purchase_orders/new')}
          >
            {t('common.button.new')}
          </Button>
        }
      />
      <PurchaseOrderListView
        service={purchaseOrderService}
        role="admin"
        supplierService={supplierService}
        addJob={addJob}
      />
    </div>
  )
}
